import { render } from "./SearchFilterRight.vue?vue&type=template&id=47664653"
import script from "./SearchFilterRight.vue?vue&type=script&lang=js"
export * from "./SearchFilterRight.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__